import ActionTypes from '@constants/action_types.js'

export function changeAdVisibility(value) {
  return {
    type: ActionTypes.AD_VISIBILITY_CHANGE,
    payload: value,
  }
}

export function changeAdChannel(value) {
  return {
    type: ActionTypes.AD_CHANNEL_CHANGE,
    payload: value,
  }
}
